<mat-card>
    <mat-card-content>
        <mat-card-title>Notifikasi</mat-card-title>
        <mat-card-subtitle>
        </mat-card-subtitle>
        <div class="row">
            <div *ngIf="dataSource.length === 0" class="center-col">Tidak ada notifikasi</div>
            <!-- <mat-list>
                <mat-list-item *ngFor="let item of dataSource" class="cursor-pointer">
                    
                </mat-list-item>
            </mat-list> -->
            <div *ngFor="let item of dataSource" class="cursor-pointer padding-12">
                <span>{{item.content}}</span><br>
                <span matLine class="text-muted">{{ dateFormat(item.dateCreated) }}</span>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div class="row">
            <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="reload($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>